export const virtualtablecss = {
  '&::-webkit-scrollbar': { width: '16px', border: '5px solid white' },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#c1c1c1',
    backgroundClip: 'padding-box',
    border: '0.05em solid #eeeeee',
    borderRadius: '0px'
  },
  '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1' },
  '&::-webkit-scrollbar-button:single-button': {
    backgroundColor: '#f1f1f1',
    display: 'block',
    borderStyle: 'solid',
    height: '13px',
    width: '16px'
  },

  // Down
  '&::-webkit-scrollbar-button:single-button:vertical:decrement': {
    borderWidth: '0 8px 8px 8px',
    borderColor: 'transparent transparent #555555 transparent'
  },
  '&::-webkit-scrollbar-button:single-button:vertical:decrement:hover': {
    borderColor: 'transparent transparent #777777 transparent'
  },

  // Up
  '&::-webkit-scrollbar-button:single-button:vertical:increment': {
    borderWidth: '8px 8px 0 8px',
    borderColor: '#555555 transparent transparent transparent'
  },
  '&::-webkit-scrollbar-button:vertical:single-button:increment:hover': {
    borderColor: '#777777 transparent transparent transparent'
  },

  // Right
  '&::-webkit-scrollbar-button:single-button:horizontal:increment': {
    borderWidth: '6px 0 6px 12px',
    borderColor: 'transparent transparent transparent #555555'
  },
  '&::-webkit-scrollbar-button:horizontal:single-button:increment:hover': {
    borderColor: 'transparent transparent transparent #777777'
  },

  // Left
  '&::-webkit-scrollbar-button:single-button:horizontal:decrement': {
    borderWidth: '6px 12px 6px 0',
    borderColor: 'transparent #555555 transparent transparent'
  },
  '&::-webkit-scrollbar-button:horizontal:single-button:decrement:hover': {
    borderColor: 'transparent #777777 transparent transparent'
  },

  fontFamily: 'var(--font)',
  '& .header-cell': {
    padding: '5px 0px',
    textAlign: 'center',
    maxHeight: '32px',
    '& div': {
      lineHeight: '1em',
      fontSize: '1rem',
      fontFamily: 'var(--font) !important',
      fontWeight: '800',
      color: 'black',
      width: '100%',
      maxHeight: '32px',
      whiteSpace: 'nowrap'
    }
  },
  '& .cell': {
    borderBottom: '1px solid #eee',
    borderLeft: '1px solid #eee',
    textAlign: 'center',
    paddingBottom: '5px',
    paddingTop: '5px'
  },
  '& .row-container:hover': {
    backgroundColor: '#fcfcfc'
  }
}